import styled from 'styled-components';

export const StyledTbmListInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  margin: 20px;

  background-color: var(--color-white);
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 0px 25px 0px #00000033;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-size: 16px;
      font-weight: 600;
      color: var(--color-text-main);
    }
  }

  .body {
  }
`;

export const StyledWorkRisk = styled.div`
  .tbm-table-task-level {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-ALL {
      border: 1px solid #58bdcb;
      border-radius: 4px;
      color: #58bdcb;
      margin: 0px 16px 0px 16px;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      text-align: center;
      padding: 3px 12px;
    }

    &-GENERAL {
      border: 1px solid #67b18f;
      border-radius: 4px;
      color: #67b18f;
      margin: 0px 16px 0px 16px;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      text-align: center;
      padding: 3px 12px;
    }

    &-HIGH_RISK {
      border: 1px solid #de3e47;
      border-radius: 4px;
      color: #de3e47;
      margin: 0px 16px 0px 16px;
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      text-align: center;
      padding: 3px 12px;
    }
  }
`;
